module.exports = __webpack_public_path__ + "static/media/socials-youtube-color.16babeb0.svg";